import type { StudioJobType } from '../studioTypes'
import { messagesNow } from '@/i18n'
import { messages } from './messages'

/**
 * Четыре студийных прогона. Запись ИСЧЕРПЫВАЮЩАЯ: пятый тип в `StudioJobType`
 * обязан сломать сборку здесь, а не тихо уехать в фолбэк.
 */
type Messages = (typeof messages)['ru']

const STUDIO_LABELS: Record<StudioJobType, (m: Messages) => string> = {
  course_generation: (m) => m.jobCourseGeneration,
  course_image_generation: (m) => m.jobCourseImageGeneration,
  // Множественное число: тот же прогон правит и один блок, и весь урок —
  // индикатор пишет «Правка блоков: 3 из 10» (M-5).
  course_block_edit: (m) => m.jobCourseBlockEdit,
  course_translation: (m) => m.jobCourseTranslation,
}

/**
 * Прогоны ВНЕ студии: их заводят MCP-сервер авторов и статейные ручки. В
 * плашке занятости и в индикаторе прогресса они не появляются никогда, зато
 * появляются в истории движений — автор за них заплатил так же, и «неизвестный
 * тип прогона» над картинкой, которую он сам же и заказал, выглядит поломкой.
 * Проверено живьём на проде 16.09.2026: без этих записей большинство строк
 * истории у автора с MCP подписаны фолбэком.
 *
 * `Map`, а не объектный литерал: тип приходит СЫРОЙ строкой контракта, и ключ
 * `constructor` у литерала вернул бы функцию мимо `??` — то есть в подпись
 * уехал бы кусок кода.
 */
const LABELS = new Map<string, (m: Messages) => string>([
  ...Object.entries(STUDIO_LABELS),
  ['image_generation', (m) => m.jobImageGeneration],
  ['image_edit', (m) => m.jobImageEdit],
  ['article_translation', (m) => m.jobArticleTranslation],
  ['article_seo_generation', (m) => m.jobArticleSeo],
])

/**
 * Единственный словарь человеческих подписей типа прогона. Подключён к плашке
 * занятости (`CourseBusyNotice`), индикатору прогресса (`GenerationProgress`) и
 * подробностям списания (`HistoryDetailDialog`) — один прогон обязан называться
 * везде одинаково (Task 8, ревью раунд 1, I-4).
 *
 * Принимает СТРОКУ, а не только `StudioJobType`: история движений отдаёт тип
 * сырым полем контракта. Фолбэк на `null`/`undefined`/незнакомый тип — та же
 * защита, что у `rawByType` в `jobProgress.ts:22-31`: молчаливая пустая строка
 * («Курс занят прогоном #45 ()») хуже честного «неизвестный тип».
 */
export const jobTypeLabel = (type: string | null | undefined): string =>
  knownJobTypeLabel(type) ?? messagesNow(messages).jobUnknown

/** То же, но `null` на незнакомом типе — когда у места есть свой фолбэк получше. */
export const knownJobTypeLabel = (type: string | null | undefined): string | null =>
  (type ? LABELS.get(type)?.(messagesNow(messages)) : undefined) ?? null
